import Assistance from './Assistance.view';

export default Assistance;